import { useMemo } from 'react';
import { Box } from '@chakra-ui/react';
import 'react-quill/dist/quill.snow.css';
import dynamic from 'next/dynamic';

const Quill = ({ setHtml, templateValue, readOnly = false, theme = 'snow' }) => {
  /** To avoid an error, must import react quill this way in nextjs */
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const ReactQuill = useMemo(() => dynamic(() => import('react-quill'), { ssr: false }), [templateValue]);
  return (
    <Box borderWidth="1px">
      <ReactQuill
        theme={theme} // pass a falsy value to use the minimal theme
        style={{ fontSize: '25px', fontFamily: 'Helvetica', maxHeight: '500px', overflowY: 'scroll' }}
        defaultValue={templateValue}
        readOnly={readOnly}
        onChange={(e) => {
          setHtml(e);
        }}
      />
    </Box>
  );
};

export default Quill;
